import EmberHeadlessUiDialog from 'ember-headlessui/components/dialog.js';
import { action } from '@ember/object';

export default class extends EmberHeadlessUiDialog {
  @action
  allowOutsideClick(e) {
    const target = e.target;

    if (target && target.tagName !== 'BODY') {
      this.outsideClickedElement = target;
    }

    if (
      !this.#didClickOnNonClosingElement(target) &&
      !this.#didClickOnScrollbar(e)
    ) {
      this.onClose();
    }

    return true;
  }

  #didClickOnNonClosingElement($target) {
    let $node = $target;

    while ($node !== null) {
      // A click inside a notification
      if ($node.hasAttribute('data-ui-notification')) {
        return true;
      }

      // A click inside the Pendo Designer UI or Pendo elements put in dialogs
      if (
        $node.classList &&
        [...$node.classList].some((className) => className.includes('pendo'))
      ) {
        return true;
      }

      $node = $node.parentElement;
    }

    return false;
  }

  #didClickOnScrollbar(event) {
    const $target = event.target;
    const rect = $target.getBoundingClientRect();

    // Check for the vertical scrollbar
    const isVerticalScrollbar =
      event.clientX > rect.right - 20 &&
      event.clientX <= rect.right &&
      $target.scrollHeight > $target.clientHeight;

    // Check for the horizontal scrollbar
    const isHorizontalScrollbar =
      event.clientY > rect.bottom - 20 &&
      event.clientY <= rect.bottom &&
      $target.scrollWidth > $target.clientWidth;

    return isVerticalScrollbar || isHorizontalScrollbar;
  }
}
